// extracted by mini-css-extract-plugin
module.exports = {"headerPhoneBox":"style_headerPhoneBox__1G1Op","headerPhone":"style_headerPhone__25CKK","icon":"style_icon__1xo96","number":"style_number__2WKHO","text":"style_text___hP4M"};